import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { SharedService } from '../../../../../modules/shared/services/shared.service';

@Component({
    selector: 'default-setup',
    templateUrl: './default-setup.view.html',
	providers: []
})
export class DefaultSetupView implements OnInit {
	constructor(public sharedService: SharedService) {
	}
	ngOnInit() {

	}

	closePopup() {
	}
}
